export default "__VITE_ASSET__4afc3485__"